import { render, staticRenderFns } from "./CompanyLicenseEdit.vue?vue&type=template&id=1b9324b6&scoped=true&"
import script from "./CompanyLicenseEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyLicenseEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLicenseEdit.vue?vue&type=style&index=0&id=1b9324b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9324b6",
  null
  
)

export default component.exports